import React, { useEffect, useState } from 'react'
import { SessionContext } from 'src/contexts/SessionContext'
import { companyInfo } from "src/components/Organizator/utils"
import { generateRandomArray, shuffleArray } from "src/helpers"
import { AppCompaniesChoices } from "src/types"

interface ISessionProvider extends React.HTMLAttributes<HTMLDivElement> {
}

const SessionProvider: React.FC<ISessionProvider> = (props) => {
    const { children } = props

    const [currentRound, setCurrentRound] = useState<number>(0)
    const [rounds, setRounds] = useState<AppCompaniesChoices[]>([])
    const [prompts, setPrompts] = useState<number[]>([])
    const currentCompany = rounds[currentRound] as AppCompaniesChoices

    const recalculate = () => {
        // Фильтруем, чтобы список не содержал Ар
        const rounds = Object.entries(companyInfo).filter(([key,]) => key !== "ar")

        // Фильтруем оплаченные компании
        const payed = rounds.filter(([, value]) => value.isP).map((company) => company[0])
        const shuffledPayed = shuffleArray(payed)

        // Определяем участника четвёртого раунда
        const fourthRoundParticipants = rounds.filter(([key, value]) => key === "h" || value.isS).map((company) => company[0])
        const fourthFiltered = fourthRoundParticipants[Math.floor(Math.random() * 2)]

        // Фильтруем бесплатных участников
        const misc = shuffleArray(rounds.filter(([key, value]) => !value.isP && !value.isS && key !== "h").map((company) => company[0]))

        // Формируем итоговый массив участников]
        const final = [...shuffledPayed, fourthFiltered, ...misc]

        setRounds(final)
        setPrompts(generateRandomArray())
    }

    const setNextRound = () => {
        setCurrentRound((prev) => prev + 1)
    }

    useEffect(() => {
        recalculate()
    }, [])

    return (
        <SessionContext.Provider
            value={{
                currentRound,
                setNextRound,
                rounds,
                prompts,
                currentCompany,
                recalculate
            }}
        >
            {children}
        </SessionContext.Provider>
    )
}

export default SessionProvider